import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./SurveyResponseStyles.scss";
import { getLocalStorage } from "../../../../helpers/utils";
import RejectionModal from "./RejectionModal";
import SurveyActions from "./SurveyActions";
import SurveyHome from "../../../Survey/SurveyHome";

export default function SurveyResponse() {
  const history = useHistory();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const selectedSurvey = getLocalStorage("SELECTED-SURVEY");

  const requestData = {
    survey_id: selectedSurvey?.id,
  };

  return (
    <>
      <div className="survey-response-wrapper">
        <div className="survey-response-title" title={selectedSurvey?.name}>
          <span
            className="left-arrow"
            onClick={() =>
              history.push({
                pathname: "./admin-survey-list",
              })
            }
          >
            <ArrowLeftOutlined />
          </span>
          {selectedSurvey?.name}
        </div>
        <SurveyActions
          selectedSurvey={selectedSurvey}
          requestData={requestData}
          setDrawerVisible={setDrawerVisible}
        />
      </div>
      <SurveyHome setDrawerVisible={setDrawerVisible} />
      <RejectionModal
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        requestData={requestData}
      />
    </>
  );
}
